<template>
  <Modal :open="open" size="big">
    <div class="space-y-5">
      <div v-if="sellerName" class="flex justify-between items-center mb-4">
        <h2 class="text-lg font-normal text-gray-900">
          Primes générées par
          <span class="font-bold">{{ sellerName }}</span>
        </h2>
      </div>

      <Table v-if="retributions" :columns="columns" :data="retributions">
        <template #sellerAmount="{ row }">
          <p class="font-semibold">{{ formatPrice(row.sellerAmount) }}</p>
        </template>
        <template #contractNumber="{ row }">
          <p class="font-semibold">{{ row.planSaleBilling.planSale.friendlyId }}</p>
        </template>
        <template #contractPrice="{ row }">
          <p>{{ formatPlanSalePrice(row.planSaleBilling.planSale) }}</p>
        </template>
        <template #contract="{ row }">
          <p>{{ row.planSaleBilling.planSale.categoryName }}</p>
        </template>
        <template #creationDate="{ row }">
          <p>{{ row.planSaleBilling.planSale.date }}</p>
        </template>
        <template #customer="{ row }">
          <p>{{ row.planSaleBilling.planSale.customer.fullName }}</p>
        </template>
        <template #email="{ row }">
          <p>{{ row.planSaleBilling.planSale.customer.email }}</p>
        </template>
      </Table>
    </div>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";
import { Modal, Table, formatPrice, toCamelCase } from "@estaly/ui";

export default {
  components: { Modal, Table },

  props: ["sellerId", "startAt", "endAt", "open"],

  data: () => {
    return {
      retributions: [],
    };
  },

  async beforeMount() {
    await this.fetchRetributions();
  },

  watch: {
    open(newValue) {
      if (newValue) {
        this.fetchRetributions();
      } else {
        this.retributions = [];
      }
    },
  },

  computed: {
    columns() {
      return [
        { label: "Contrat", field: "planSaleBilling", slot: "contractNumber" },
        { label: "Date", field: "planSaleBilling", slot: "creationDate" },
        { label: "Formule", field: "planSaleBilling", slot: "contract" },
        { label: "Client", field: "customer", slot: "customer" },
        { label: "Email", field: "email", slot: "email" },
        { label: "Prix du contrat", field: "planSaleBilling", slot: "contractPrice", numeric: true },
        { label: "Prime", field: "sellerAmount", slot: "sellerAmount", numeric: true },
      ];
    },

    sellerName() {
      return this.retributions?.[0]?.seller?.name || "";
    },
  },

  methods: {
    formatPrice,
    ...mapActions("retributions", ["fetchIndex"]),
    formatPlanSalePrice(planSale) {
      return planSale.monthly ? formatPrice(planSale.price) + " / mois" : formatPrice(planSale.price);
    },
    async fetchRetributions() {
      if (!this.sellerId || !this.startAt || !this.endAt) return;

      const response = await this.fetchIndex({
        sellerId: this.sellerId,
        startAt: this.startAt,
        endAt: this.endAt,
        includes: [
          "seller",
          "plan_sale_billing.plan_sale.customer",
          "plan_sale_billing.plan_sale",
          "plan_sale_billing",
        ],
      });

      if (!response?.success) return;

      this.retributions = toCamelCase(response.data.retributions);
    },
  },
};
</script>
